import {ApplicationConfig, provideZonelessChangeDetection} from '@angular/core';
import {provideHttpClient} from '@angular/common/http';
import {provideRouter, RouteReuseStrategy, withComponentInputBinding, withEnabledBlockingInitialNavigation} from '@angular/router';
import {IonicRouteStrategy, provideIonicAngular} from '@ionic/angular/standalone';
import {routes} from './app.routes';

export const appConfigShared: ApplicationConfig = {
	providers: [
		provideZonelessChangeDetection(),
		{provide: RouteReuseStrategy, useClass: IonicRouteStrategy},
		provideIonicAngular({
			mode: 'md',
			innerHTMLTemplatesEnabled: true
		}),
		provideRouter(routes, withComponentInputBinding(), withEnabledBlockingInitialNavigation()),
		provideHttpClient()
	]
};
